import React from 'react';
import { motion } from 'framer-motion';
import { LightbulbIcon, CodeIcon, CpuIcon, RocketIcon } from 'lucide-react';
const steps = [{
  icon: <LightbulbIcon className="w-6 h-6" data-id="element-119" />,
  title: 'Estrategia',
  description: 'Analizamos tu negocio, mercado y objetivos para diseñar una hoja de ruta digital personalizada.'
}, {
  icon: <CodeIcon className="w-6 h-6" data-id="element-120" />,
  title: 'Desarrollo',
  description: 'Construimos tu plataforma con tecnologías modernas, asegurando rendimiento, seguridad y escalabilidad.'
}, {
  icon: <CpuIcon className="w-6 h-6" data-id="element-121" />,
  title: 'Automatización',
  description: 'Integramos IA y herramientas CRM para optimizar flujos de trabajo y mejorar la experiencia del cliente.'
}, {
  icon: <RocketIcon className="w-6 h-6" data-id="element-122" />,
  title: 'Crecimiento',
  description: 'Lanzamos campañas de marketing orientadas a datos para atraer, convertir y fidelizar usuarios.'
}];
export function ProcessSection() {
  return <section id="proceso" className="py-24 relative z-10" data-id="element-123">
      <div className="container mx-auto px-6 md:px-12" data-id="element-124">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-125">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-126">
            Nuestro proceso de{' '}
            <span className="text-brand-cyan" data-id="element-127">transformación</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-128">
            Una metodología probada que lleva tu proyecto desde la concepción
            inicial hasta el crecimiento sostenido.
          </p>
        </div>

        <div className="relative" data-id="element-129">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-brand-dark via-brand-cyan/30 to-brand-dark -translate-y-1/2 z-0" data-id="element-130"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 relative z-10" data-id="element-131">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-132">
                {/* Step Number */}
                <div className="text-brand-cyan/20 font-bold text-6xl mb-[-30px] group-hover:text-brand-cyan/40 transition-colors duration-300" data-id="element-133">
                  0{index + 1}
                </div>

                {/* Icon Container */}
                <div className="w-16 h-16 rounded-2xl bg-brand-dark border-2 border-brand-cyan/30 flex items-center justify-center text-white mb-6 relative group-hover:bg-brand-cyan group-hover:border-brand-cyan group-hover:shadow-[0_0_20px_rgba(0,212,255,0.4)] transition-all duration-300" data-id="element-134">
                  {step.icon}
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3" data-id="element-135">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-136">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}